import { api } from "services/axios/api";
import { getErrorsByApi } from "shared/helpers/getErrorsByApi";
import {
  IApiResponseTipologias,
  ITipologia,
  ITipologiaDetalhe,
  ITipologiaPerfil,
  ITipologiaComponente,
  ITipologiaImagem,
} from "shared/interfaces/tipologia";

export const getTipologias = async (params?: any): Promise<ITipologia[]> => {
  try {
    const { data } = await api.get<IApiResponseTipologias>(
      "/Tipologia/ListarTipologias",
      {
        params: {
          page: params?.page,
          limit: params?.pageSize,
          sortBy: params?.sortBy,
          direction: params?.direction,
          projetistaId: params?.projetistaId,
          linhaId: params?.linhaId,
          situacao: params?.situacao,
          apenasDisponibilizadas: params?.apenasDisponibilizadas,
          busca: params?.search || "",
          codigo: params?.codigo || "",
          descricao: params?.descricao || "",
          linha: params?.linha || "",
          projetistasIds: params?.projetistasIds,
        },
      }
    );
    return data.items ?? [];
  } catch (error: any) {
    const errorMessage =
      error?.response?.data?.errors?.Mensagens?.[0] ||
      "Tivemos problemas internos ao buscar as Tipologias";
    getErrorsByApi(error, errorMessage);
    console.error("[API ERROR]", error?.response?.status, error);
    return [];
  }
};

export const getDadosPaginacao = async (params?: any): Promise<number> => {
  try {
    const { data } = await api.get<IApiResponseTipologias>(
      "/Tipologia/ListarTipologias",
      {
        params: {
          page: params?.page,
          limit: params?.pageSize,
          sortBy: params?.sortBy,
          direction: params?.direction,
          projetistaId: params?.projetistaId,
          linhaId: params?.linhaId,
          situacao: params?.situacao,
          apenasDisponibilizadas: params?.apenasDisponibilizadas,
          busca: params?.search || "",
          codigo: params?.codigo || "",
          descricao: params?.descricao || "",
          linha: params?.linha || "",
          projetistasIds: params?.projetistasIds,
        },
      }
    );
    return data?.totalRecords || 0;
  } catch (error: any) {
    const errorMessage =
      error?.response?.data?.errors?.Mensagens?.[0] ||
      "Tivemos problemas internos ao buscar as Tipologias";
    getErrorsByApi(error, errorMessage);
    return 0;
  }
};

export const getTipologiaPorId = async (
  idTipologia: number
): Promise<ITipologiaDetalhe | null> => {
  try {
    const { data } = await api.get<ITipologiaDetalhe>(
      "/Tipologia/ObterTipologiaPorId",
      {
        params: { idTipologia },
      }
    );
    return data;
  } catch (error: any) {
    const errorMessage =
      error?.response?.data?.errors?.Mensagens?.[0] ||
      "Tivemos problemas internos ao buscar a Tipologia";
    getErrorsByApi(error, errorMessage);
    return null;
  }
};

export const getTipologiaPerfis = async (
  tipologiaId: number,
  busca?: string
): Promise<ITipologiaPerfil[]> => {
  try {
    const { data } = await api.get<ITipologiaPerfil[]>(
      "/Tipologia/ListarPerfis",
      {
        params: { tipologiaId, busca },
      }
    );
    return data ?? [];
  } catch (error: any) {
    const errorMessage =
      error?.response?.data?.errors?.Mensagens?.[0] ||
      "Tivemos problemas internos ao buscar os Perfis da Tipologia";
    getErrorsByApi(error, errorMessage);
    console.error("[API ERROR]", error?.response?.status, error);
    return [];
  }
};

export const getTipologiaComponentes = async (
  tipologiaId: number,
  busca?: string
): Promise<ITipologiaComponente[]> => {
  try {
    const { data } = await api.get<ITipologiaComponente[]>(
      "/Tipologia/ListarComponentes",
      {
        params: { tipologiaId, busca },
      }
    );
    return data ?? [];
  } catch (error: any) {
    const errorMessage =
      error?.response?.data?.errors?.Mensagens?.[0] ||
      "Tivemos problemas internos ao buscar os Componentes da Tipologia";
    getErrorsByApi(error, errorMessage);
    console.error("[API ERROR]", error?.response?.status, error);
    return [];
  }
};

export const getTipologiaImagens = async (
  tipologiaId: number
): Promise<ITipologiaImagem[]> => {
  try {
    const { data } = await api.get<ITipologiaImagem[]>(
      "/Tipologia/ListarImagens",
      {
        params: { tipologiaId },
      }
    );
    return data ?? [];
  } catch (error: any) {
    const errorMessage =
      error?.response?.data?.errors?.Mensagens?.[0] ||
      "Tivemos problemas internos ao buscar as Imagens da Tipologia";
    getErrorsByApi(error, errorMessage);
    console.error("[API ERROR]", error?.response?.status, error);
    return [];
  }
};

